import React from 'react';

import { Button } from '$partials/ui';
import { formatLinkBlockToUrl } from '$utilities/format';
import { Media } from '$partials/media';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').ColumnTextMediaBlock}
 */

const ColumnTextMedia = ({
    autoplay,
    title,
    richText,
    backgroundColor,
    media,
    ctaCssClass,
    ctaLabel,
    ctaLink
}) => {
    const bgColor = `bg-surface-panel-${backgroundColor}`;
    return (
        <section className={`${bgColor} col-padding pt-24 pb-8 md:pb-16 grid sm:grid-cols-2 gap-y-24 sm:gap-y-0 gap-x-8 md:gap-x-16 rounded-lg`}>
            <div className='w-full'>
                <h2 className='type-style-sans-h1 mb-8 w-full md:w-4/6'>
                    {title}
                </h2>
                {richText && (
                    <div
                        className='rich-text type-style-sans-h3 column-text-media md:pr-[156px]'
                        dangerouslySetInnerHTML={{__html:richText}} />
                )}
                {ctaLabel && (
                    <Button
                        as='a'
                        className={`button-primary-xl mt-24 md:mt-40 self-start${ctaCssClass ? ' ' + ctaCssClass : ''}`}
                        href={formatLinkBlockToUrl(ctaLink)}>
                        {ctaLabel}
                    </Button>
                )}
            </div>
            {media && (
                <figure className='rounded-lg overflow-hidden h-[193px] sm:h-[264px] md:h-[382px]'>
                    <Media {
                        ...{
                            ...media,
                            ...(media.image ? {
                                image: {
                                    ...media?.image,
                                    className: 'h-full w-full object-cover',
                                    containerStyle: {
                                        height: '100%'
                                    },
                                    containerClassName: 'rounded-lg overflow-hidden pointer-events-none select-none'
                                }
                            } : {}),
                            ...(media.videoEmbed ? {
                                videoEmbed: {
                                    ...media.videoEmbed,
                                    autoPlay: autoplay,
                                    poster: media?.videoEmbed?.poster || media?.videoEmbed?.embed?.thumbnailUrl
                                }
                            } : {} ),
                            ...(media.video ? {
                                video: {
                                    ...media.video,
                                    autoPlay: autoplay,
                                    showControls: !autoplay,
                                    loop: autoplay,
                                }
                            } : {} )
                        }
                    }/>
                </figure>
            )}
        </section>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default ColumnTextMedia;
